import React from "react";
import {
  ToggleButtonGroup,
  ToggleButton,
  Typography,
  Box,
} from "@mui/material";
import {
  AREA_USE_PURPOSE_DATA_SOURCE,
  type AreaUsePurposeDataSource,
} from "@/constants/areaUsePurposeDataSource";

interface Props {
  value: AreaUsePurposeDataSource;
  onChange: (
    event: React.MouseEvent<HTMLElement>,
    value: AreaUsePurposeDataSource | null
  ) => void;
  showDescription?: boolean;
}

/**
 * 用途地域データソース選択トグルボタン
 * 「都市計画決定GISデータ」と「国土数値情報」を切り替えるトグルボタン
 */
export const AreaUsePurposeDataSourceToggle: React.FC<Props> = ({
  value,
  onChange,
  showDescription = true,
}) => {
  return (
    <Box>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={onChange}
        size="small"
        aria-label="用途地域データソース選択"
        sx={{
          "& .MuiToggleButton-root": {
            "&.Mui-selected": {
              backgroundColor: "primary.main",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "primary.dark",
                color: "#FFFFFF",
              },
            },
          },
        }}
      >
        <ToggleButton
          value={AREA_USE_PURPOSE_DATA_SOURCE.CITY_PLANNING}
          aria-label="都市計画決定GISデータ"
        >
          都市計画決定GISデータ
        </ToggleButton>
        <ToggleButton
          value={AREA_USE_PURPOSE_DATA_SOURCE.NATIONAL_LAND}
          aria-label="国土数値情報"
        >
          国土数値情報
        </ToggleButton>
      </ToggleButtonGroup>
      {showDescription && (
        <Typography
          variant="body2"
          sx={{ mt: 1, color: "primary.main", fontWeight: "medium" }}
        >
          ※ 用途地域・容積率・建ぺい率のデータソースを切り替えることが可能です。
        </Typography>
      )}
    </Box>
  );
};
